import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=76b95801&"
import script from "./Events.vue?vue&type=script&lang=js&"
export * from "./Events.vue?vue&type=script&lang=js&"
import style0 from "./Events.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b95801')) {
      api.createRecord('76b95801', component.options)
    } else {
      api.reload('76b95801', component.options)
    }
    module.hot.accept("./Events.vue?vue&type=template&id=76b95801&", function () {
      api.rerender('76b95801', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/History/Events.vue"
export default component.exports